import { CloseIcon } from 'assets/icons/CloseIcon'
import { Modal } from 'components/Modal/Modal'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex, ItemsGrid, ModalScrollContainer, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IGetAllInventoryRequestsSingleResponse } from 'types/api/inventoryItems.interface'
import { formatDateForDisplay } from 'utils/helpers'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { inventoryRequestStatuses } from './InventoryRequests'

export const ViewInventoryRequestModal = ({ closeModal, value }: { closeModal: any, value?: IGetAllInventoryRequestsSingleResponse }) => {
    useFocusFirstInput()
    useModalClose(closeModal)

    return <Modal black>
        <ModalScrollContainer>
            <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                <TitleText weight='bold' >Request Preview</TitleText>
                <CursorPointer onClick={closeModal} >
                    <CloseIcon />
                </CursorPointer>
            </Flex>
            <ItemsGrid columns={2} >
                <TextDisplayCard width='100%' title={formatDateForDisplay(value.createdAt)} labelText='Created At' />
                <TextDisplayCard width='100%' title={value.type == 1 ? 'Assign' : 'Unassign'} labelText='Type' />
                <TextDisplayCard width='100%' title={inventoryRequestStatuses.find(s => s.value == value.status).label} labelText='Type' />
                <TextDisplayCard width='100%' title={value.location ? value.location.name : '/'} labelText='Location' />
            </ItemsGrid>

            <TextDisplayCard style={{ marginTop: 16 }} title={value.notes || '/'} labelText='Notes' width='100%' />

            <ThinSeparator />
            <Flex column gap='1rem'  >
                <BodyText weight='bold' >Items:</BodyText>
                {value.lines.map(l => <Flex key={l.id} width='100%' gap='1rem' >
                    <TextDisplayCard width='100%' title={l.inventoryItem ? l.inventoryItem.name : '/'} labelText='Item' />
                    <TextDisplayCard width='100%' title={l.quantity} labelText='Quantity' />
                </Flex>)}
            </Flex>
        </ModalScrollContainer>
    </Modal>
}

